/* eslint-disable complexity */
// MUST be removed when we removed teh useSiteRebrand
import { Fragment } from "react";

import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Typography,
} from "@mui/material";

import { LiveChat } from "components/LiveChat/LiveChat";
import { MenuNodeType } from "components/Menu/model";
import { useAutoFocus } from "hooks/useAutoFocus";
import { useAvoTracking } from "hooks/useAvoTracking";

import { MenuSectionLabelNode } from "../MenuSectionLabelNode";
import { sharedStyles } from "../shared.styles";

import { contactMenuStyles } from "./ContactMenu.styles";

const icons = {
  phone: <PhoneIcon />,
  mail: <EmailIcon />,
};

export const ContactMenu = ({ node }: { node: MenuNodeType.Container }) => {
  const { trackMenuClick } = useAvoTracking();
  const htmlAnchorRef = useAutoFocus<HTMLAnchorElement>(true);

  if (!node.childNodes) return null;

  return (
    <>
      <Box css={sharedStyles.headerContainer}>
        <Typography
          variant="h2"
          css={sharedStyles.headerText}
          data-testid="contact-menu-header"
        >
          {node.titleKey}
        </Typography>
      </Box>
      <Divider css={sharedStyles.headerDivider} />
      {node.childNodes.map((childNode, index) => {
        const {
          analyticsTag,
          href,
          icon,
          nodeType,
          titleKey: childTitleKey,
        } = childNode as MenuNodeType.Link;

        const isSeeAllLink = node.childNodes!.length - 1 === index;
        if (nodeType === "sectionLabel") {
          return (
            <Fragment key={index}>
              <Divider data-testid="contact-menu-divider" />
              <MenuSectionLabelNode titleKey={childTitleKey} />
            </Fragment>
          );
        } else {
          if (analyticsTag === "Live Chat") {
            return <LiveChat key={index} />;
          }
          return (
            <Fragment key={index}>
              {isSeeAllLink && <Divider data-testid="contact-menu-divider" />}
              <MenuItem
                component="a"
                key={index}
                href={href}
                tabIndex={0}
                {...(index === 0 && { ref: htmlAnchorRef })}
                onClick={(e) => {
                  trackMenuClick({
                    containerLinkText: node.analyticsTag,
                    name: analyticsTag,
                    redirectLinkProps: {
                      mouseEventHandler: e,
                      redirectUrl: href,
                    },
                  });
                }}
              >
                {icon && (
                  <ListItemIcon>
                    {icons[icon as keyof typeof icons]}
                  </ListItemIcon>
                )}
                <ListItemText
                  css={isSeeAllLink && contactMenuStyles.seeAllLinkStyles}
                >
                  {childTitleKey}
                </ListItemText>
              </MenuItem>
            </Fragment>
          );
        }
      })}
    </>
  );
};
